module.exports = __webpack_public_path__ + "static/media/geolocalizacion-Brios-Desktop.ad1e06aa.webp";